module.exports = __webpack_public_path__ + "static/media/story-banner.d4a63743.svg";